import types from "../types";

export const setShowModalIntegrationNotFound = (open) => ({
  type: types.ALERTS_SHOW_MODAL_INTEGRATION_NOT_FOUND,
  payload: open,
});

export const setIntegrationsNotFound = (list) => ({
  type: types.ALERTS_SET_INTEGRATIONS_NOT_FOUND,
  payload: list,
});

/**
 * When an endpoint returns ok: true but includes failedIntegrations (partial
 * platform failures), show the same modal as integration-not-found errors.
 * Does not replace an alert that is already open or has pending items.
 */
export const openIntegrationNotFoundModalIfNeeded =
  (failedIntegrations) => (dispatch, getState) => {
    if (!Array.isArray(failedIntegrations) || failedIntegrations.length === 0) {
      return;
    }
    const current = getState()?.alerts?.integrationNotFound;
    if (current?.open || current?.items?.length > 0) return;
    dispatch(setIntegrationsNotFound(failedIntegrations));
    dispatch(setShowModalIntegrationNotFound(true));
  };

export const resetIntegrationNotFound = () => ({
  type: types.ALERTS_RESET_INTEGRATION_NOT_FOUND,
});

export const setPendingIntegrationFormSync = (payload) => ({
  type: types.ALERTS_SET_PENDING_INTEGRATION_FORM_SYNC,
  payload,
});

export const consumePendingIntegrationFormSyncForCampaign = (campaignID) => ({
  type: types.ALERTS_CONSUME_PENDING_INTEGRATION_FORM_SYNC_FOR_CAMPAIGN,
  payload: campaignID,
});

// Generic notification actions
export const addNotification = (notificationData) => ({
  type: types.ALERTS_ADD_NOTIFICATION,
  payload: notificationData,
});

export const updateNotification = (notificationID, updates) => ({
  type: types.ALERTS_UPDATE_NOTIFICATION,
  payload: {
    id: notificationID,
    updates,
  },
});

export const removeNotification = (notificationID) => ({
  type: types.ALERTS_REMOVE_NOTIFICATION,
  payload: {
    id: notificationID,
  },
});

export const clearAllNotifications = () => ({
  type: types.ALERTS_CLEAR_ALL_NOTIFICATIONS,
});

export const syncCreativeJobNotificationsAction = (notifications) => ({
  type: types.ALERTS_SYNC_CREATIVE_JOB_NOTIFICATIONS,
  payload: notifications,
});

export const promoteCreativeNotification = ({ fromId, jobID }) => ({
  type: types.ALERTS_PROMOTE_CREATIVE_NOTIFICATION,
  payload: { fromId, jobID },
});
